/* global globalThis */
const STORAGE_KEY = "orator-browser-id";
let browserIdentity;

export function deviceKind(navigator = {}) {
  const agent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  if (/iPad/.test(agent) || (platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "iPad";
  if (/iPhone|iPod/.test(agent)) return "iPhone";
  if (/Android/.test(agent)) return "Android";
  if (/Win/.test(platform) || /Windows/.test(agent)) return "Windows";
  if (/Mac/.test(platform) || /Macintosh/.test(agent)) return "Mac";
  if (/Linux/.test(platform)) return "Linux";
  return "Browser";
}

export function createBrowserIdentity(storage, navigator, crypto) {
  let id;
  try { id = storage?.getItem(STORAGE_KEY); } catch { /* Storage can be unavailable in private browsing. */ }
  if (!/^[a-f0-9]{32}$/.test(id || "")) {
    id = Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, "0")).join("");
    try { storage?.setItem(STORAGE_KEY, id); } catch { /* Keep a page-lifetime identity when storage is blocked. */ }
  }
  const kind = deviceKind(navigator);
  return { id, kind, label: `${kind} ${id.slice(0, 6).toUpperCase()}` };
}

export function getBrowserIdentity() {
  if (!browserIdentity) {
    let storage;
    try { storage = globalThis.localStorage; } catch { /* Access itself may throw. */ }
    browserIdentity = createBrowserIdentity(storage, globalThis.navigator, globalThis.crypto);
  }
  return browserIdentity;
}

export function screenForPath(path = "") {
  const screen = path.split("/").filter(Boolean).at(-1);
  return ({ queue: "Queue", manage: "Queue", presenter: "Presenter", "lower-thirds": "Lower Thirds",
    participants: "Participants", "orator-prep": "Orator Prep" })[screen] || "Ceremony";
}
